import { GlLoader } from '@adl/component-loader'

import loaderStyles from './loader-styles.module.scss'

const LoadingScreen = () => {
  return (
    <div className={loaderStyles.loader}>
      <GlLoader />
    </div>
  )
}

export default LoadingScreen
